import React, { useEffect, useRef, useState } from "react";
import Main from "./Main";
import Header2 from "../../layout/Header2";
import Footer from "../../layout/Footer";
import { useNavigate } from "react-router-dom";
import Loading from "../../components/Loading";
import { fetchData } from "../../features/dashboardSlice/dashboardApi";
import { useSelector, useDispatch } from "react-redux";

const Dashboard = () => {
  const state = useSelector((state) => state.dashboard);
  const [selectedListName,setSelectedListName] = useState('All')
  const [spinner,setIsSpinner] = useState(false);
  const [initialLoader,setinitialLoader] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isFirstRender = useRef(true);

  useEffect( () => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      setDashboard(true);
    } else {
      setDashboard(false);
    }
  }, [selectedListName]);


  async function setDashboard(isFirst) {
    try {
      let list = selectedListName == "All" ? '' : selectedListName
      if (isFirst) {
        setinitialLoader(true);
      } else {
        setIsSpinner(true);
      }
      await dispatch(fetchData({ navigate,selectedListName:list }));
      if (isFirst) {
        setinitialLoader(false);
      } else {
        setIsSpinner(false);
      }
    } catch (error) {
      if (isFirst) {
        setinitialLoader(false);
      } else {
        setIsSpinner(false);
      }
      console.error(error)
    }
  }

  return (
    <>
      <Header2 />
      {initialLoader && !spinner ? (
        <div className="flex justify-center items-center flex-1">
          <Loading />
        </div>
      ) : (
        <>
          <Main selectedListName={selectedListName} setSelectedListName={setSelectedListName} isLoading={spinner}/>
        </>
      )}
      <Footer />
    </>
  );
};

export default Dashboard;
